import { Card } from '@/components/ui/card';

const ProfileTab = ({ user }) => {
  return (
    <Card className="p-8 border-0 shadow-sm rounded-2xl bg-white">
      <h2 className="text-2xl font-tajawal font-bold mb-6 text-brand-black border-b pb-4">المعلومات الشخصية</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-gray-50 p-4 rounded-xl">
          <label className="font-tajawal font-bold text-gray-500 text-sm mb-1 block">الاسم</label>
          <p className="font-cairo text-lg font-semibold text-brand-black">{user.full_name || user.name}</p>
        </div>
        <div className="bg-gray-50 p-4 rounded-xl">
          <label className="font-tajawal font-bold text-gray-500 text-sm mb-1 block">البريد الإلكتروني</label>
          <p className="font-cairo text-lg font-semibold text-brand-black">{user.email}</p>
        </div>
        <div className="bg-gray-50 p-4 rounded-xl md:col-span-2">
          <label className="font-tajawal font-bold text-gray-500 text-sm mb-1 block">رقم الهاتف</label>
          <p className="font-cairo text-lg font-semibold text-brand-black" dir="ltr">{user.phone || 'غير محدد'}</p>
        </div>
      </div>
    </Card>
  );
};

export default ProfileTab;
